export default __webpack_public_path__ + "static/media/Snd_6_Starts.a14504c6.mp3";